import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
import { useHomePage } from '~/pages/HomePage/HomePageProvider';
export function useIdentitySwapWindow() {
    const { setIsSwitchingBusiness } = useStoreActions();
    const { setHidden } = useHomePage();
    const beginIdentitySwap = useCallback(()=>{
        setIsSwitchingBusiness(true);
        setHidden(true);
    }, []);
    const abandonIdentitySwap = useCallback(()=>{
        setIsSwitchingBusiness(false);
        setHidden(false);
    }, []);
    return {
        beginIdentitySwap,
        abandonIdentitySwap
    };
}
